module.exports = __webpack_public_path__ + "assets/img/preview.af1735aea049926f8ccf68b2d83d35ae.jpg";